import { GraphQLFieldConfig, GraphQLList, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { QuickFilterType, QuickFilter } from '../types/quick-filter'
import {
  libraryFilterArgs,
  LibraryFilterQueryArgs
} from '../types/library-filter-query-args'
import {
  appendLibraryFiltersToBody,
  ContrastQueryParameters
} from '../endpoint-helpers'

function normalizeQuickFilter({ name, count, filterType }): QuickFilter {
  return {
    id: filterType,
    count,
    name
  }
}

export const libraryQuickFilters: GraphQLFieldConfig<
  any,
  Context,
  LibraryFilterQueryArgs
> = {
  description: 'Get library quick filters for an organization',
  type: new GraphQLNonNull(new GraphQLList(QuickFilterType)),
  args: libraryFilterArgs,
  async resolve(_source, args, context): Promise<QuickFilter[]> {
    const { organizationID, filters } = args

    const params = new ContrastQueryParameters()

    const mappedFilters = appendLibraryFiltersToBody(filters)

    params.append('expand', 'skip_links,quickFilters')
    params.append('offset', 0)

    const { quickFilters = [] } = await context.connector.post(
      `/${organizationID}/libraries/filter?${params}`,
      mappedFilters
    )

    return quickFilters.map(normalizeQuickFilter)
  }
}
